module.exports = __webpack_public_path__ + "static/media/icon-location.126bf2e0.svg";